var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsString, Matches } from 'class-validator';
import { CALENDAR_DATE } from './calendar-date.js';
/**
 * Body of
 * `PATCH /v1/office-locations/:officeLocationId/abrechnungsbeauftragung/ends-on`
 * (#1615).
 *
 * An endpoint of its own beside accepting and changing the date, because
 * TM-9636 puts a step-up guard of its own in front of each of them.
 */
export class EndAbrechnungsbeauftragungDto {
    /**
     * Last covered day, **inclusive**, `YYYY-MM-DD`. Tomorrow or later and not
     * before the beginning. Settable once.
     */
    endsOn;
}
__decorate([
    IsString(),
    Matches(CALENDAR_DATE, { message: 'endsOn must be formatted YYYY-MM-DD.' }),
    __metadata("design:type", String)
], EndAbrechnungsbeauftragungDto.prototype, "endsOn", void 0);
//# sourceMappingURL=end-abrechnungsbeauftragung.dto.js.map